document.addEventListener('DOMContentLoaded', function() {
  /* =========== Mobile Menu =========== */
  var mobileToggle = document.querySelector('.header__mobile-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      mobileToggle.innerHTML = mobileMenu.classList.contains('active') ? '✕' : '☰';
    });
  }

  /* =========== FAQ Accordion =========== */
  document.querySelectorAll('.faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = this.nextElementSibling;
      var isOpen = answer.classList.contains('open');
      document.querySelectorAll('.faq__answer.open').forEach(function(a) { a.classList.remove('open'); });
      document.querySelectorAll('.faq__question').forEach(function(q) { q.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        answer.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* =========== Product Gallery =========== */
  var currentIndex = 0;
  var galleryImages = document.querySelectorAll('.product-gallery__main-image');
  var galleryThumbs = document.querySelectorAll('.product-gallery__thumb');

  function showImage(index) {
    if (!galleryImages.length) return;
    if (index < 0) index = galleryImages.length - 1;
    if (index >= galleryImages.length) index = 0;
    currentIndex = index;
    galleryImages.forEach(function(i) { i.classList.remove('active'); });
    galleryImages[currentIndex].classList.add('active');
    galleryThumbs.forEach(function(t) { t.classList.remove('active'); });
    if (galleryThumbs[currentIndex]) galleryThumbs[currentIndex].classList.add('active');
  }

  // Thumb clicks
  galleryThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() { showImage(parseInt(this.dataset.thumbIndex)); });
  });

  // Arrow navigation
  var prevBtn = document.getElementById('gallery-prev');
  var nextBtn = document.getElementById('gallery-next');
  if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); showImage(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); showImage(currentIndex + 1); });

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft' && document.querySelector('.product-gallery__main:hover')) showImage(currentIndex - 1);
    if (e.key === 'ArrowRight' && document.querySelector('.product-gallery__main:hover')) showImage(currentIndex + 1);
  });

  /* =========== Image Zoom (Magnifier) =========== */
  var galleryMain = document.getElementById('product-gallery-main');
  var zoomLens = document.getElementById('zoom-lens');
  var zoomResult = document.getElementById('zoom-result');
  if (galleryMain && zoomLens && zoomResult && window.innerWidth > 1200) {
    galleryMain.addEventListener('mouseenter', function() {
      var activeImg = this.querySelector('.product-gallery__main-image.active img');
      if (activeImg) {
        zoomLens.style.display = 'block';
        zoomResult.style.display = 'block';
        zoomResult.style.backgroundImage = 'url(' + activeImg.src.replace(/_800x/g, '_1200x') + ')';
      }
    });
    galleryMain.addEventListener('mousemove', function(e) {
      var rect = this.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var lensW = zoomLens.offsetWidth / 2;
      var lensH = zoomLens.offsetHeight / 2;
      var lx = Math.min(Math.max(x - lensW, 0), rect.width - zoomLens.offsetWidth);
      var ly = Math.min(Math.max(y - lensH, 0), rect.height - zoomLens.offsetHeight);
      zoomLens.style.left = lx + 'px';
      zoomLens.style.top = ly + 'px';
      var px = (lx / (rect.width - zoomLens.offsetWidth)) * 100;
      var py = (ly / (rect.height - zoomLens.offsetHeight)) * 100;
      zoomResult.style.backgroundPosition = px + '% ' + py + '%';
      zoomResult.style.backgroundSize = (rect.width * 2.5) + 'px ' + (rect.height * 2.5) + 'px';
    });
    galleryMain.addEventListener('mouseleave', function() {
      zoomLens.style.display = 'none';
      zoomResult.style.display = 'none';
    });
  }

  /* =========== Product Tabs =========== */
  document.querySelectorAll('.product-tabs__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tab = this.dataset.tab;
      document.querySelectorAll('.product-tabs__btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.product-tabs__panel').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      var panel = document.getElementById('tab-' + tab);
      if (panel) panel.classList.add('active');
    });
  });

  /* =========== Quantity Selector =========== */
  document.querySelectorAll('.product-info__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('input');
      var val = parseInt(input.value) || 1;
      if (this.classList.contains('qty-plus')) { input.value = val + 1; }
      else if (val > 1) { input.value = val - 1; }
    });
  });

  /* =========== Cart Count Sync =========== */
  function updateCartCount() {
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function(){});
  }
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = '...'; }
      var fd = new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:fd})
        .then(function(r){return r.json()})
        .then(function(){
          if (btn) { btn.disabled = false; btn.textContent = '🛒'; }
          updateCartCount();
        })
        .catch(function(){ if (btn) { btn.disabled = false; btn.textContent = '🛒'; } });
    });
  });
});
